export default __webpack_public_path__ + "0b91d149b6b919ca9ea9f90eb769c49e.png";